var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _path3, _path4, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path5, _path6, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _path7, _path8, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _path9, _path0, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _path1, _path10, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _path11, _path12, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _path13, _path14, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _path15, _path16, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _path17, _path18, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _path19, _path20, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _path21, _path22, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _path23, _path24, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _path25, _path26, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _path27, _path28, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _path29, _path30, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualProcessesStacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 112,
    viewBox: "0 0 127 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 68.5046L91.1543 88.9949L39.9653 59.4409V63.4409L91.1543 92.9949L126.644 72.5046V68.5046Z",
    fill: "#E4E4E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 68.5046L91.1543 88.9949L39.9653 59.4409V63.4409L91.1543 92.9949L126.644 72.5046V68.5046Z",
    fill: "url(#paint0_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 59.4409)",
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 60.8882)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 63.4692)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 54.4448)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 70.9556)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 73.5366)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 76.1177)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 78.6987)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 81.2798)",
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 83.8608)",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 63.6618L91.1543 84.1521L39.9653 54.5981V58.5981L91.1543 88.1521L126.644 67.6618V63.6618Z",
    fill: "#E4E4E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 63.6618L91.1543 84.1521L39.9653 54.5981V58.5981L91.1543 88.1521L126.644 67.6618V63.6618Z",
    fill: "url(#paint1_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 54.5981)",
    fill: "#FAFAFA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 56.0454)",
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 58.6265)",
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 49.6021)",
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 66.1128)",
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 68.6938)",
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 71.2749)",
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 73.856)",
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 76.437)",
    fill: "#D9D9D9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 79.0181)",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 58.7893L91.1543 79.2795L39.9653 49.7256V53.7256L91.1543 83.2795L126.644 62.7893V58.7893Z",
    fill: "#E4E4E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 58.7893L91.1543 79.2795L39.9653 49.7256V53.7256L91.1543 83.2795L126.644 62.7893V58.7893Z",
    fill: "url(#paint2_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 49.7256)",
    fill: "#FAFAFA"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 51.1724)",
    fill: "#D9D9D9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 53.7534)",
    fill: "#D9D9D9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 44.7295)",
    fill: "#D9D9D9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 61.2402)",
    fill: "#D9D9D9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 63.8213)",
    fill: "#D9D9D9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 66.4023)",
    fill: "#D9D9D9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 68.9834)",
    fill: "#D9D9D9"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 71.5645)",
    fill: "#D9D9D9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 74.1455)",
    fill: "#D9D9D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 53.9167L91.1543 74.407L39.9653 44.853V48.853L91.1543 78.407L126.644 57.9167V53.9167Z",
    fill: "#E4E4E4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 53.9167L91.1543 74.407L39.9653 44.853V48.853L91.1543 78.407L126.644 57.9167V53.9167Z",
    fill: "url(#paint3_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 44.853)",
    fill: "#FAFAFA"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 46.3003)",
    fill: "#D9D9D9"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 48.8813)",
    fill: "#D9D9D9"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 39.8569)",
    fill: "#D9D9D9"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 56.3677)",
    fill: "#D9D9D9"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 58.9487)",
    fill: "#D9D9D9"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 61.5298)",
    fill: "#D9D9D9"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 64.1108)",
    fill: "#D9D9D9"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 66.6919)",
    fill: "#D9D9D9"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 69.2729)",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 49.0442L91.1543 69.5344L39.9653 39.9805V43.9805L91.1543 73.5344L126.644 53.0442V49.0442Z",
    fill: "#E4E4E4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 49.0442L91.1543 69.5344L39.9653 39.9805V43.9805L91.1543 73.5344L126.644 53.0442V49.0442Z",
    fill: "url(#paint4_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 39.9805)",
    fill: "#FAFAFA"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 41.4272)",
    fill: "#D9D9D9"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 44.0083)",
    fill: "#D9D9D9"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 34.9844)",
    fill: "#D9D9D9"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 51.4951)",
    fill: "#D9D9D9"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 54.0762)",
    fill: "#D9D9D9"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 56.6572)",
    fill: "#D9D9D9"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 59.2383)",
    fill: "#D9D9D9"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 61.8193)",
    fill: "#D9D9D9"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 64.4004)",
    fill: "#D9D9D9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 44.1716L91.1543 64.6619L39.9653 35.1079V39.1079L91.1543 68.6619L126.644 48.1716V44.1716Z",
    fill: "#E4E4E4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 44.1716L91.1543 64.6619L39.9653 35.1079V39.1079L91.1543 68.6619L126.644 48.1716V44.1716Z",
    fill: "url(#paint5_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 35.1079)",
    fill: "#FAFAFA"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 36.5552)",
    fill: "#D9D9D9"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 39.1362)",
    fill: "#D9D9D9"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 30.1118)",
    fill: "#D9D9D9"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 46.6226)",
    fill: "#D9D9D9"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 49.2036)",
    fill: "#D9D9D9"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 51.7847)",
    fill: "#D9D9D9"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 54.3657)",
    fill: "#D9D9D9"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 56.9468)",
    fill: "#D9D9D9"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 59.5278)",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 39.2991L91.1543 59.7893L39.9653 30.2354V34.2354L91.1543 63.7893L126.644 43.2991V39.2991Z",
    fill: "#E4E4E4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 39.2991L91.1543 59.7893L39.9653 30.2354V34.2354L91.1543 63.7893L126.644 43.2991V39.2991Z",
    fill: "url(#paint6_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 30.2354)",
    fill: "#FAFAFA"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 31.6821)",
    fill: "#D9D9D9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 34.2632)",
    fill: "#D9D9D9"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 25.2393)",
    fill: "#D9D9D9"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 41.75)",
    fill: "#D9D9D9"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 44.3311)",
    fill: "#D9D9D9"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 46.9121)",
    fill: "#D9D9D9"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 49.4932)",
    fill: "#D9D9D9"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 52.0742)",
    fill: "#D9D9D9"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 54.6553)",
    fill: "#D9D9D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 34.4265L91.1543 54.9167L39.9653 25.3628V29.3628L91.1543 58.9167L126.644 38.4265V34.4265Z",
    fill: "#E4E4E4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 34.4265L91.1543 54.9167L39.9653 25.3628V29.3628L91.1543 58.9167L126.644 38.4265V34.4265Z",
    fill: "url(#paint7_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 25.3628)",
    fill: "#FAFAFA"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 26.8101)",
    fill: "#D9D9D9"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 29.3911)",
    fill: "#D9D9D9"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 20.3667)",
    fill: "#D9D9D9"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 36.8774)",
    fill: "#D9D9D9"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 39.4585)",
    fill: "#D9D9D9"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 42.0396)",
    fill: "#D9D9D9"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 44.6206)",
    fill: "#D9D9D9"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 47.2017)",
    fill: "#D9D9D9"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 49.7827)",
    fill: "#D9D9D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 29.5539L91.1543 50.0442L39.9653 20.4902V24.4902L91.1543 54.0442L126.644 33.5539V29.5539Z",
    fill: "#E4E4E4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.644 29.5539L91.1543 50.0442L39.9653 20.4902V24.4902L91.1543 54.0442L126.644 33.5539V29.5539Z",
    fill: "url(#paint8_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 39.9653 20.4902)",
    fill: "#FAFAFA"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.8516 21.937)",
    fill: "#D9D9D9"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 52.3223 24.5181)",
    fill: "#D9D9D9"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 80.9189 15.4941)",
    fill: "#D9D9D9"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 65.2891 32.0049)",
    fill: "#D9D9D9"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 69.7598 34.5859)",
    fill: "#D9D9D9"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 74.23 37.167)",
    fill: "#D9D9D9"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 78.7007 39.748)",
    fill: "#D9D9D9"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 83.1709 42.3291)",
    fill: "#D9D9D9"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 87.6416 44.9102)",
    fill: "#D9D9D9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 86.6692L51.1889 107.159L0 77.6055V81.6055L51.1889 111.159L86.6791 90.6692V86.6692Z",
    fill: "#E4E4E4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 86.6692L51.1889 107.159L0 77.6055V81.6055L51.1889 111.159L86.6791 90.6692V86.6692Z",
    fill: "url(#paint9_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 0 77.6055)",
    fill: "#FAFAFA"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 7.88623 79.0522)",
    fill: "#D9D9D9"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 12.3569 81.6333)",
    fill: "#D9D9D9"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 40.9536 72.6094)",
    fill: "#D9D9D9"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 25.3237 89.1201)",
    fill: "#D9D9D9"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 29.7944 91.7012)",
    fill: "#D9D9D9"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 34.2646 94.2822)",
    fill: "#D9D9D9"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 38.7354 96.8633)",
    fill: "#D9D9D9"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 43.2056 99.4443)",
    fill: "#D9D9D9"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.6763 102.025)",
    fill: "#D9D9D9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 81.8264L51.1889 102.317L0 72.7627V76.7627L51.1889 106.317L86.6791 85.8264V81.8264Z",
    fill: "#E4E4E4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 81.8264L51.1889 102.317L0 72.7627V76.7627L51.1889 106.317L86.6791 85.8264V81.8264Z",
    fill: "url(#paint10_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 0 72.7627)",
    fill: "#FAFAFA"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 7.88623 74.2095)",
    fill: "#D9D9D9"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 12.3569 76.7905)",
    fill: "#D9D9D9"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 40.9536 67.7666)",
    fill: "#D9D9D9"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 25.3237 84.2773)",
    fill: "#D9D9D9"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 29.7944 86.8584)",
    fill: "#D9D9D9"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 34.2646 89.4395)",
    fill: "#D9D9D9"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 38.7354 92.0205)",
    fill: "#D9D9D9"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 43.2056 94.6016)",
    fill: "#D9D9D9"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.6763 97.1826)",
    fill: "#D9D9D9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 76.9538L51.1889 97.4441L0 67.8901V71.8901L51.1889 101.444L86.6791 80.9538V76.9538Z",
    fill: "#E4E4E4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 76.9538L51.1889 97.4441L0 67.8901V71.8901L51.1889 101.444L86.6791 80.9538V76.9538Z",
    fill: "url(#paint11_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 0 67.8901)",
    fill: "#FAFAFA"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 7.88623 69.3374)",
    fill: "#D9D9D9"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 12.3569 71.9185)",
    fill: "#D9D9D9"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 40.9536 62.894)",
    fill: "#D9D9D9"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 25.3237 79.4048)",
    fill: "#D9D9D9"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 29.7944 81.9858)",
    fill: "#D9D9D9"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 34.2646 84.5669)",
    fill: "#D9D9D9"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 38.7354 87.1479)",
    fill: "#D9D9D9"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 43.2056 89.729)",
    fill: "#D9D9D9"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.6763 92.3101)",
    fill: "#D9D9D9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 72.0813L51.1889 92.5715L0 63.0176V67.0176L51.1889 96.5715L86.6791 76.0813V72.0813Z",
    fill: "#E4E4E4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 72.0813L51.1889 92.5715L0 63.0176V67.0176L51.1889 96.5715L86.6791 76.0813V72.0813Z",
    fill: "url(#paint12_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 0 63.0176)",
    fill: "#FAFAFA"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 7.88623 64.4644)",
    fill: "#D9D9D9"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 12.3569 67.0454)",
    fill: "#D9D9D9"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 40.9536 58.0215)",
    fill: "#D9D9D9"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 25.3237 74.5322)",
    fill: "#D9D9D9"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 29.7944 77.1133)",
    fill: "#D9D9D9"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 34.2646 79.6943)",
    fill: "#D9D9D9"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 38.7354 82.2754)",
    fill: "#D9D9D9"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 43.2056 84.8564)",
    fill: "#D9D9D9"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.6763 87.4375)",
    fill: "#D9D9D9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 67.2087L51.1889 87.699L0 58.145V62.145L51.1889 91.699L86.6791 71.2087V67.2087Z",
    fill: "#E4E4E4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 67.2087L51.1889 87.699L0 58.145V62.145L51.1889 91.699L86.6791 71.2087V67.2087Z",
    fill: "url(#paint13_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 0 58.145)",
    fill: "#FAFAFA"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 7.88623 59.5923)",
    fill: "#D9D9D9"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 12.3569 62.1733)",
    fill: "#D9D9D9"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 40.9536 53.1489)",
    fill: "#D9D9D9"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 25.3237 69.6597)",
    fill: "#D9D9D9"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 29.7944 72.2407)",
    fill: "#D9D9D9"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 34.2646 74.8218)",
    fill: "#D9D9D9"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 38.7354 77.4028)",
    fill: "#D9D9D9"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 43.2056 79.9839)",
    fill: "#D9D9D9"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.6763 82.5649)",
    fill: "#D9D9D9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 62.3362L51.1889 82.8264L0 53.2725V57.2725L51.1889 86.8264L86.6791 66.3362V62.3362Z",
    fill: "#E4E4E4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 62.3362L51.1889 82.8264L0 53.2725V57.2725L51.1889 86.8264L86.6791 66.3362V62.3362Z",
    fill: "url(#paint14_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 0 53.2725)",
    fill: "#FAFAFA"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 7.88623 54.7192)",
    fill: "#D9D9D9"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 12.3569 57.3003)",
    fill: "#D9D9D9"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 40.9536 48.2764)",
    fill: "#D9D9D9"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 25.3237 64.7871)",
    fill: "#D9D9D9"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 29.7944 67.3682)",
    fill: "#D9D9D9"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 34.2646 69.9492)",
    fill: "#D9D9D9"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 38.7354 72.5303)",
    fill: "#D9D9D9"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 43.2056 75.1113)",
    fill: "#D9D9D9"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.6763 77.6924)",
    fill: "#D9D9D9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 57.4636L51.1889 77.9539L0 48.3999V52.3999L51.1889 81.9539L86.6791 61.4636V57.4636Z",
    fill: "#E4E4E4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.6791 57.4636L51.1889 77.9539L0 48.3999V52.3999L51.1889 81.9539L86.6791 61.4636V57.4636Z",
    fill: "url(#paint15_linear_60176_507)",
    fillOpacity: 0.2
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 40.9805,
    height: 59.1079,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 0 48.3999)",
    fill: "#FAFAFA"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7393,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 7.88623 49.8472)",
    fill: "#D9D9D9"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 12.3569 52.4282)",
    fill: "#D9D9D9"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 8.33984,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 40.9536 43.4038)",
    fill: "#D9D9D9"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 25.3237 59.9146)",
    fill: "#D9D9D9"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 29.7944 62.4956)",
    fill: "#D9D9D9"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 34.2646 65.0767)",
    fill: "#D9D9D9"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 38.7354 67.6577)",
    fill: "#D9D9D9"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 33.8745,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 43.2056 70.2388)",
    fill: "#D9D9D9"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 12.2524,
    height: 2.16211,
    transform: "matrix(0.866025 -0.5 0.866025 0.5 47.6763 72.8198)",
    fill: "#D9D9D9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3218 68.6616C74.4955 68.6616 83.5542 77.4671 83.5542 88.3296C83.5542 99.192 74.4955 107.998 63.3218 107.998C52.1482 107.997 43.0903 99.1919 43.0903 88.3296C43.0903 77.4673 52.1482 68.6618 63.3218 68.6616ZM63.3218 85.2241L56.8101 78.894L53.6157 81.9995L60.1274 88.3296L53.6157 94.6606L56.8101 97.7661L63.3218 91.4351L69.8335 97.7661L73.0288 94.6606L66.5161 88.3296L73.0278 81.9995L69.8335 78.894L63.3218 85.2241Z",
    fill: "#D92D17"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60176_507",
    x1: 126.644,
    y1: 88.736,
    x2: 39.9653,
    y2: 63.6998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60176_507",
    x1: 126.644,
    y1: 83.8932,
    x2: 39.9653,
    y2: 58.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_60176_507",
    x1: 126.644,
    y1: 79.0207,
    x2: 39.9653,
    y2: 53.9844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_60176_507",
    x1: 126.644,
    y1: 74.1481,
    x2: 39.9653,
    y2: 49.1119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_60176_507",
    x1: 126.644,
    y1: 69.2755,
    x2: 39.9653,
    y2: 44.2393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_60176_507",
    x1: 126.644,
    y1: 64.403,
    x2: 39.9653,
    y2: 39.3668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_60176_507",
    x1: 126.644,
    y1: 59.5304,
    x2: 39.9653,
    y2: 34.4942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_60176_507",
    x1: 126.644,
    y1: 54.6579,
    x2: 39.9653,
    y2: 29.6216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_60176_507",
    x1: 126.644,
    y1: 49.7853,
    x2: 39.9653,
    y2: 24.7491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_60176_507",
    x1: 86.6791,
    y1: 106.901,
    x2: -0.00000151387,
    y2: 81.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_60176_507",
    x1: 86.6791,
    y1: 102.058,
    x2: -0.00000151387,
    y2: 77.0216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_60176_507",
    x1: 86.6791,
    y1: 97.1852,
    x2: -0.00000151387,
    y2: 72.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_60176_507",
    x1: 86.6791,
    y1: 92.3127,
    x2: -0.00000151387,
    y2: 67.2764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_60176_507",
    x1: 86.6791,
    y1: 87.4401,
    x2: -0.00000151387,
    y2: 62.4039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_60176_507",
    x1: 86.6791,
    y1: 82.5675,
    x2: -0.00000151387,
    y2: 57.5313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_60176_507",
    x1: 86.6791,
    y1: 77.695,
    x2: -0.00000151387,
    y2: 52.6588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.278494,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualProcessesStacks);
export default __webpack_public_path__ + "static/media/manual-processes-stacks.13372515368985f406c0f2d68c0d827e.svg";
export { ForwardRef as ReactComponent };